import { Icons } from '@/app/components/ui/Icons'
import { useTranslations } from 'next-intl'
import classNames from 'classnames'
import { FC } from 'react'

const BookingPlaceholder: FC = () => {
	const t = useTranslations('Form')
	return (
		<div
			className={classNames('booking__form', {
				'max-lg:pt-6 max-lg:border border-text-300 md:max-lg:mb-5 md:max-lg:mx-5': true,
				// Note: header-wrapper adds max-lg:py-3 max-lg:px-2 on main page
				// This padding is handled by the parent wrapper
			})}
		>
			{/* Mobile title placeholder (visual skeleton, no text) */}
			<div className="lg:hidden mb-4 px-3">
				<div className="mx-auto h-[33px] w-4/5 rounded-full bg-text-200" />
			</div>

			<div
				className={classNames(
					'booking w-full flex lg:mt-8 justify-center flex-wrap mx-auto',
					'max-lg:px-3 xl:max-w-[1048px] lg:max-xl:container'
				)}
			>
				<div className="booking__wrapper">
					{/* Location Input */}
					<div
						className={classNames(
							'flex-1 w-full lg:h-full md:max-lg:mb-2 max-lg:mb-3',
							{
								'lg:my-0': true,
							}
						)}
					>
						<div className="booking__placeholder-input-wrapper booking__placeholder-location-input">
							<Icons.iconPin className="input-icon" />
							<input
								type="text"
								className="booking__placeholder-input h-14 rounded-full"
								placeholder="Enter a city or hotel"
								readOnly
							/>
						</div>
					</div>

					{/* Date Inputs */}
					<div className="booking__placeholder-date-inputs">
						<div className="max-lg:w-full lg:w-[164px] booking__placeholder-input-wrapper">
							<Icons.iconCalendarFrom className="input-icon" />
							<input
								type="text"
								className="booking__placeholder-input"
								placeholder="Check-in"
								readOnly
							/>
						</div>
						<div className="divider-small w-[1px] lg:w-2 bg-text-300 lg:bg-text-400 h-[30px] lg:h-[1px]"></div>
						<div className="max-lg:w-full lg:w-[164px] booking__placeholder-input-wrapper">
							<Icons.iconCalendarTo className="input-icon" />
							<input
								type="text"
								className="booking__placeholder-input"
								placeholder="Check-out"
								readOnly
							/>
						</div>
					</div>

					{/* Rooms & Guests Input */}
					<div className="booking__guests-input booking__additional-input booking__placeholder-rooms-input">
						<div className="booking__placeholder-input-wrapper">
							<Icons.iconGuests className="input-icon" />
							<input
								type="text"
								className="booking__placeholder-input outline-none max-lg:h-14 rounded-full"
								placeholder={t('roomsAndGuests', { roomsCount: 1, guestsCount: 2 })}
								readOnly
							/>
						</div>
					</div>

					{/* Search Button - Desktop */}
					<div
						data-test="search-button"
						className="hidden lg:block lg:order-2 xl:order-none"
					>
						<button
							className="booking__placeholder-button w-fit flex items-center justify-center"
							disabled
						>
							<Icons.iconLens className="xl:mr-3" />
							<span className="hidden xl:inline whitespace-nowrap">
								{t('newDesign.searchButton')}
							</span>
						</button>
					</div>
				</div>

				{/* Mobile compare & signup placeholder (between form and CTA) */}
				<div className="block lg:hidden w-full mt-6 px-3 space-y-4">
					<div className="flex items-center space-x-3">
						<div className="h-5 w-5 rounded bg-text-200" />
						<div className="h-4 flex-1 rounded-full bg-text-200" />
					</div>
				</div>

				{/* Search Button - Mobile */}
				<div
					data-test="search-button"
					className="block lg:hidden w-full max-lg:mt-6 lg:px-2 lg:order-3 xl:order-none"
				>
					<button
						className="booking__placeholder-button w-full flex items-center justify-center"
						disabled
					>
						<Icons.iconLens className="mr-3" />
						<span className="whitespace-nowrap">
							{t('newDesign.searchButtonMobile')}
						</span>
					</button>
				</div>

				{/* Checkboxes Section Placeholder - Desktop */}
				<div
					className={classNames(
						'hidden lg:order-2 xl:order-none w-full xl:max-w-[1040px]',
						{
							'lg:flex': true, // Always show on main page placeholder
						}
					)}
				>
					<div className="flex items-center justify-start mt-4 w-full ps-2 lg:ps-5 pe-2 lg:pe-5 mb-4 lg:mb-0">
						{/* Price Alert Switch Placeholder */}
						<div className="price-alert-switch">
							<div className="booking__placeholder-checkbox-wrapper flex items-center">
								<div className="booking__placeholder-checkbox-label me-3 max-lg:text-sm font-semibold" />
								<div className="booking__placeholder-checkbox" />
								<div className="booking__placeholder-checkbox-label ms-2 max-lg:text-sm font-semibold" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default BookingPlaceholder
